import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Main.scss";

function Main({ posts, cat }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [items, setItems] = useState([]);

  const getText = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent;
  };
  const trimText = (txt) => {
    txt = txt.slice(0, 300);
    return `${txt}...`;
  };
  const processTitle = (title) => {
    title = title.slice(10).replace(/=/g, " ");
    return title.toUpperCase();
  };
  function getRandomItems(array, count) {
    const shuffled = array.sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  }
  const addItem = (newItem) => {
    setItems((prevItems) => [...prevItems, newItem]);
  };
  useEffect(() => {
    // Update the window width when it changes
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="main">
      <div className="main-container">
        {cat ? (
          <p
            style={{ fontSize: "1.25rem", margin: "0 0 2rem 0" }}
            className="main__category"
          >
            {processTitle(cat)}
          </p>
        ) : (
          <h3 className="main__title">Latest Posts</h3>
        )}
        <div className="main__content">
          {windowWidth > 768 && windowWidth <= 991
            ? getRandomItems(posts, 6).map((item) => (
                <Link
                  className="main__content__list__link"
                  to={`/posts/${item.id}`}
                  key={item.id}
                >
                  <div className="main__content__list">
                    <div className="main__content__list__img">
                      <img src={`../upload/${item.imgURL}`} alt="bread" />
                    </div>
                    <div className="main__content__list__text">
                      <h2 className="main__content__list__text-title">
                        {item.title}
                      </h2>

                      <span className="main__content__list__text-content">
                        {trimText(getText(item.content))}
                      </span>

                      <button className="btns">Read More</button>
                    </div>
                  </div>
                </Link>
              ))
            : getRandomItems(posts, 8).map((item) => (
                <Link
                  className="main__content__list__link"
                  to={`/posts/${item.id}`}
                  key={item.id}
                >
                  <div className="main__content__list">
                    <div className="main__content__list__img">
                      <img src={`../upload/${item.imgURL}`} alt="bread" />
                    </div>
                    <div className="main__content__list__text">
                      <h2 className="main__content__list__text-title">
                        {item.title}
                      </h2>

                      <span className="main__content__list__text-content">
                        {trimText(getText(item.content))}
                      </span>

                      <button className="btns">Read More</button>
                    </div>
                  </div>
                </Link>
              ))}
        </div>
      </div>
    </div>
  );
}

export default Main;
